import React, { useEffect, useState } from "react";
import { MdOutlineFilterList } from "react-icons/md";
import { useSelector } from "react-redux";
import { Row, Col } from "react-bootstrap";
import { AiOutlineClose, AiOutlineSwapRight } from "react-icons/ai";
import { FiMaximize2 } from "react-icons/fi";
import moment from "moment";
import { FaArrowRightLong } from "react-icons/fa6";
import { Calendar, Clock, Package, Check, ArrowLeft } from "lucide-react";
import { ApiPaths } from "../../Config/ApiPath";
import { BasicInfo } from "../../Config/BasicInfo";
import PaginationComponent from "../../Components/PaginationControls/PaginationControls";
import useAxiosHelper from "../../Common/AxiosHelper";
import Loader from "../../Components/Loader/Loader";
import Timer from "../../Components/Timer";
const PrincipalWithdrawalHistory = ({ refresh, onBack }) => {
  const [filterVisibility, setFilterVisibility] = useState(false);
  const [loading, setLoading] = useState(false);
  const [paymentTransaction, setPaymentTransaction] = useState([]);
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [totalPages, setTotalPages] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [selectedImage, setSelectedImage] = useState(null); // State to manage selected image
  const { AxiosGet } = useAxiosHelper();
  const incomeData = useSelector((state) => state.incomeData?.incomeWallet);
  const [companyData, setCompanyData] = useState([]);
  const [limitFilter, setLimitFilter] = useState(10);
  const [search, setSearch] = useState({
    startDate: "",
    endDate: "",
  });
  var x = 0;
  useEffect(() => {
    if (x === 0) {
      CompanyInfo();
      FetchData();
      x++;
    }
  }, [refresh]);
  async function CompanyInfo() {
    try {
      const data = localStorage.getItem("companyData");
      setCompanyData(JSON.parse(data));
    } catch (error) {
      BasicInfo.isDebug && console.log(error);
    }
  }
  var y = 0;
  useEffect(() => {
    if (y == 0) {
      FetchData(currentPage);
      y++;
    }
  }, [currentPage]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    console.log(name, value);
    setSearch((prev) => ({ ...prev, [name]: value }));
  };

  const AddFilter = () => {
    const queryParams = {
      page: currentPage,
      limit: limitFilter,
      ...Object.fromEntries(
        Object.entries(search).filter(
          ([_, value]) => value !== "" && value !== 0
        )
      ),
    };
    FetchData(queryParams);
  };

  const FetchData = async (page = currentPage) => {
    try {
      const filteredSearch = Object.fromEntries(
        Object.entries(search).filter(([key, value]) => value !== "")
      );

      const filters = {
        source: "principal_withdrawal",
      };
      const queryParams = {
        page,
        limit: limitFilter,
        ...filters,
      };

      setLoading(true);
      const response = await AxiosGet(
        `${ApiPaths.getPaymentTransaction}?${new URLSearchParams(
          queryParams
        ).toString()}`
      );
      BasicInfo.isDebug && console.log("Fund history", response);

      setPaymentTransaction(response?.data || []);
      setTotalPages(response?.totalPages || 1);
    } catch (error) {
      console.error("Error fetching payment transactions:", error);
    } finally {
      setLoading(false);
    }
  };

  const handlePagination = (page) => {
    setCurrentPage(page);
  };

  function resetData() {
    setSearch({
      startDate: "",
      endDate: "",
    });
    setLimitFilter(10);
  }

  useEffect(() => {
    if (search.startDate === "" && search.endDate === "") {
      FetchData();
    }
  }, [search]);
  const handleSearch = () => {
    setCurrentPage(1); // Reset to first page on search
    FetchData(1);
  };

  const openImagePopup = (imageUrl) => {
    setSelectedImage(imageUrl); // Set selected image for popup
  };

  const closeImagePopup = () => {
    setSelectedImage(null); // Close popup by setting image to null
  };

  return (
    <>
      {loading && <Loader />}

      <section className="dashboard">
        <div className="incomeSelectBox">
          <p
            onClick={onBack}
            style={{
              color: "var(--textColor)",
              opacity: "0.8",
              cursor: "pointer",
            }}
          >
            {" "}
            <ArrowLeft size={16} /> Back
          </p>

          <button onClick={() => setFilterVisibility(!filterVisibility)}>
            {filterVisibility ? "Hide Filters" : "Show Filters"}
            <i>
              <MdOutlineFilterList />
            </i>
          </button>
        </div>
        {filterVisibility && (
          <section className="filtersection inputPrimary">
            <Row>
              <Col lg="2" md="4" xs="12">
                <input
                  type="date"
                  placeholder="From Date"
                  name="startDate"
                  value={search.startDate}
                  onChange={handleChange}
                />
              </Col>
              <Col lg="2" md="4" xs="12">
                <input
                  type="date"
                  placeholder="End Date"
                  name="endDate"
                  value={search.endDate}
                  onChange={handleChange}
                />
              </Col>
              <Col lg="2" md="4" xs="6">
                <button onClick={AddFilter}>Search</button>
              </Col>
              <Col lg="2" md="4" xs="6">
                <button onClick={resetData}>Reset</button>
              </Col>
            </Row>
          </section>
        )}

        <div className="incomeHistoryTableSection">
          <h2 className="incomeBreakdownTitle">Principal Withdrawal History</h2>
          <div className="incomeHistoryTableWrapper">
            <table className="incomeHistoryTable">
              <thead>
                <tr>
                  <th>S.No</th>
                  <th>
                    Instant Withdrawal Amount ({companyData?.currency_sign})
                  </th>
                  <th>Instant Withdrawal Status</th>
                  <th>Hold Amount ({companyData?.currency_sign})</th>
                  <th>Hold Status</th>
                  <th>Hold Time</th>
                  <th>Date</th>
                </tr>
              </thead>
              <tbody>
                {paymentTransaction.length ? (
                  paymentTransaction.map((x, i) => (
                    <tr key={i}>
                      <td>{(currentPage - 1) * limitFilter + (i + 1)}</td>
                      <td className="incomeHistoryAmount">
                        {companyData?.token_sign}
                        {parseFloat(x?.amount).toFixed(2)}
                      </td>
                      <td>
                        {x?.status == "1" ? (
                          <span className="incomeHistoryStatus success">
                            Success
                          </span>
                        ) : x?.status == "2" ? (
                          <span className="incomeHistoryStatus rejected">
                            Rejected
                          </span>
                        ) : (
                          <span className="incomeHistoryStatus pending">
                            Pending
                          </span>
                        )}
                      </td>

                      <td>{parseFloat(x?.hold_amount).toFixed(2)}</td>
                      <td>
                        {x?.hold_status == "1" ? (
                          <span className="incomeHistoryStatus success">
                            Success
                          </span>
                        ) : x?.hold_status == "2" ? (
                          <span className="incomeHistoryStatus rejected">
                            Rejected
                          </span>
                        ) : (
                          <span className="incomeHistoryStatus pending">
                            Pending
                          </span>
                        )}
                      </td>

                      <td style={{ color: "var(--cyanIcon)" }}>
                        <Timer
                          endDate={x?.hold_until}
                          status={x?.hold_status}
                        />
                      </td>
                      <td>{moment(x?.time).format("lll")}</td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="5">No history yet</td>
                  </tr>
                )}
              </tbody>
            </table>
            {paymentTransaction.length > 0 && (
              <PaginationComponent
                currentPage={currentPage}
                totalPages={totalPages}
                onPageChange={handlePagination}
              />
            )}
          </div>
        </div>

        {/* Image Popup */}
        {selectedImage && (
          <div className="popup">
            <div className="popup-content">
              <span className="close-icon" onClick={closeImagePopup}>
                <AiOutlineClose />
              </span>
              <img src={selectedImage} alt="proof" className="popup-image" />
            </div>
          </div>
        )}
      </section>
    </>
  );
};

export default PrincipalWithdrawalHistory;
